/* eslint-disable no-underscore-dangle, no-use-before-define */

import PropTypes from 'prop-types'
import React from 'react'
import { View, StyleSheet } from 'react-native'
import Colors from '../../constants/Colors';
import { Avatar, Day, utils } from 'react-native-gifted-chat'
import Bubble from './SlackBubble'

const { isSameUser, isSameDay } = utils

export default class Message extends React.Component {
  getInnerComponentProps() {
    const { containerStyle, ...props } = this.props
    return {
      ...props,
      position: 'left',
      isSameUser,
      isSameDay,
    }
  }

  renderDay() {
    if (this.props.currentMessage.createdAt) {
      const dayProps = this.getInnerComponentProps()
      if (this.props.renderDay) {
        return this.props.renderDay(dayProps)
      }
      return <Day {...dayProps} />
    }
    return null
  }

    // Function to get background color based on user ID
  getBackgroundColor(userId) {
    // Define a map of user IDs to colors
    const colorMap = {
      1: 'transparent',
      2: Colors.light.hereworksBackground,
      // Add more mappings as needed
    };

    return colorMap[userId] || 'white'; // Default color if user ID not in map
  }

  renderBubble() {
    const bubbleProps = this.getInnerComponentProps();
    const userId = bubbleProps.currentMessage.user._id.toString();
    const backgroundColor = this.getBackgroundColor(userId);

    if (this.props.renderBubble) {
      return this.props.renderBubble({
        ...bubbleProps,
        wrapperStyle: {
          left: { backgroundColor },
        },
      });
    }
    return (
      <Bubble
        {...bubbleProps}
        wrapperStyle={{
          left: { backgroundColor },
        }}
      />
    );
  }

  renderAvatar() {
    let extraStyle
    if (
      isSameUser(this.props.currentMessage, this.props.previousMessage) &&
      isSameDay(this.props.currentMessage, this.props.previousMessage)
    ) {
      // Set the invisible avatar height to 0, but keep the width, padding, etc.
      extraStyle = { height: 0 }
    }

    const avatarProps = this.getInnerComponentProps()
    return (
      <Avatar
        {...avatarProps}
        imageStyle={{
          left: [styles.slackAvatar, avatarProps.imageStyle, extraStyle],
        }}
      />
    )
  }

  render() {
    const isConsecutive = isSameUser(
      this.props.currentMessage,
      this.props.nextMessage,
    );
  
    const marginBottom = isConsecutive ? 0 : 10;
  
    const backgroundColor = this.getBackgroundColor(this.props.currentMessage.user._id);
  
    return (
      <View>
        {this.renderDay()}
        <View
          style={[
            styles.container,
            { marginBottom, backgroundColor }, // Apply background color here
            this.props.containerStyle,
          ]}
        >
          {this.renderAvatar()}
          {this.renderBubble()}
        </View>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: 8,
    marginRight: 0,
  },
  slackAvatar: {
    // The bottom should roughly line up with the first line of message text.
    height: 40,
    width: 40,
    borderRadius: 20,
  },
})

Message.defaultProps = {
  renderAvatar: undefined,
  renderBubble: null,
  renderDay: null,
  currentMessage: {},
  nextMessage: {},
  previousMessage: {},
  user: {},
  containerStyle: {},
}

Message.propTypes = {
  renderAvatar: PropTypes.func,
  renderBubble: PropTypes.func,
  renderDay: PropTypes.func,
  currentMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  user: PropTypes.object,
  containerStyle: PropTypes.shape({
    left: PropTypes.any,
    right: PropTypes.any,
  }),
}